import React from "react";
import { FormattedMessage } from "react-intl";

import createBaseRenderer from "./createBaseRenderer";

import { Uzivatel, ZadostiStavPopis } from "./ciselnik";
import { DateAktivita } from "./";
import { MESSAGES } from "./i18n/useMessages";

import { ZadostHistorieItemPoznamka } from "./";

export default createBaseRenderer({
  name: "zadostHistorieItem",
  placeholderText: "23. března 17:18 Váš požadavek byl přijat.",
  content: ({ val }) => (
    <div className="b2b-ZadostHistorieItem">
      <div className="b2b-ZadostHistorieItem-datum">
        <DateAktivita val={val.datum} />
      </div>
      <div>
        <div className="b2b-ZadostHistorieItem-label">
          <div className="b2b-ZadostHistorieItem-text">
            {val.modiPoznamka ||
            val.modiPoznamkaSpravce ||
            val.modiStrojvedouci ? (
              <FormattedMessage {...MESSAGES.poznamkaModi} />
            ) : (
              <ZadostiStavPopis val={val.stav} />
            )}
          </div>
          <div className="b2b-ZadostHistorieItem-autor">
            <Uzivatel val={val.uzivatel} />
          </div>
        </div>
        <div className="b2b-ZadostHistorieItem-poznamky">
          <>
            {val.modiPoznamka ? (
              <ZadostHistorieItemPoznamka
                val={{
                  label: (
                    <FormattedMessage {...MESSAGES.poznamkaModiZakaznik} />
                  ),
                  poznamka: val.poznamka
                }}
              />
            ) : undefined}
            {val.modiPoznamkaSpravce ? (
              <ZadostHistorieItemPoznamka
                val={{
                  label: <FormattedMessage {...MESSAGES.poznamkaModiSpravce} />,
                  poznamka: val.poznamkaSpravce
                }}
              />
            ) : undefined}
            {val.modiStrojvedouci ? (
              <ZadostHistorieItemPoznamka
                val={{
                  label: (
                    <FormattedMessage {...MESSAGES.poznamkaModiStrojvedouci} />
                  ),
                  poznamka: val.strojvedouci
                }}
              />
            ) : undefined}
          </>
        </div>
      </div>
    </div>
  )
});
